import { InjectionToken } from '@angular/core';

export const CART_NAME = new InjectionToken<string>('CART_NAME');
